import { useEffect, useRef, useState } from "react";

export const useTimeParser = () => {
    const [coolDown, setSecondCoolDown] = useState(60);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        timerRef.current = setInterval(() => {
            setSecondCoolDown((prev) => {
                if (prev <= 1) {
                    clearInterval(timerRef.current!);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, []);

    const reset = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
        setSecondCoolDown(60);
        timerRef.current = setInterval(() => {
            setSecondCoolDown((prev) => {
                if (prev <= 1) {
                    clearInterval(timerRef.current!);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    return { coolDown, reset };
};
